export default
{
   ConstructionUnitStatus: [],
   ConstructionUnitStatu: {},
}
